import React from "react";
import PanelMain from "../PanelMain"
import PanelSidebar from "../PanelSidebar"
import PanelRoute from "../PanelRoute";


const PanelLayout: React.FC = props => {
    const sidebar = document.getElementById('sidebar');
    const sidebarCloseIcon = document.getElementById('sidebar-close-icon');
    const sidebarOpenIcon = document.getElementById('sidebar-open-icon');
    const overlay = document.getElementById('overlay');

    const openSidebar = () => {
        sidebar?.classList.add('absolute', 'z-50', 'flex', 'flex-row-reverse')
        sidebar?.classList.remove('hidden')

        sidebarCloseIcon?.classList.remove('hidden')
        sidebarCloseIcon?.classList.add('flex')

        document.body.classList.add('overflow-hidden')

        overlay?.classList.remove('hidden')
    }

    const closeSidebar = () => {
        sidebar?.classList.remove('absolute', 'z-50', 'flex', 'flex-row-reverse')
        sidebar?.classList.add('hidden');

        sidebarCloseIcon?.classList.add('hidden')
        sidebarCloseIcon?.classList.remove('flex')

        document.body.classList.remove('overflow-hidden')

        overlay?.classList.add('hidden')
    }

    overlay?.addEventListener('click', () => closeSidebar())
    window.addEventListener('resize', () => closeSidebar())
        
    return (
        <div className="overflow-hidden">
            <div id="overlay" className="hidden w-full h-full fixed top-0 right-0 bg-gray-900 bg-opacity-50"/>
            <PanelSidebar handleCloseSidebar={closeSidebar}/>
            <PanelMain handleOpenSidebar={openSidebar}>
                <PanelRoute />
            </PanelMain>
        </div>
    )
}

export default PanelLayout